import { OrderType } from 'enums';
import { CashbackPage } from 'features/cashback';

export const TechOperatorPayoutCashbackPage: React.FC = () => (
  <CashbackPage orderType={OrderType.Payout} />
);
